<template>
    <page-header-wrapper>
        <a-card :bordered="false">

            <!-- 查询条件 -->
            <!-- <div class="table-page-search-wrapper">
                <a-form layout="inline">
                    <a-row :gutter="48">
                        <a-col :md="8" :sm="24">
                            <a-form-item label="关键字">
                                <a-input v-model="queryParam.keyword" placeholder="请输入关键字" allow-clear />
                            </a-form-item>
                        </a-col>

                        <a-col :md="8" :sm="24">
                            <span class="table-page-search-submitButtons">
                                <a-button type="primary" @click="handleQuery">
                                    <a-icon type="search" /> 查询
                                </a-button>
                                <a-button style="margin-left: 8px" @click="resetQuery">
                                    <a-icon type="redo" /> 重置
                                </a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div> -->

            <!-- 表格 -->
            <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false"
                :bordered="tableBordered" />

            <!-- 分页 -->
            <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange" @change="changePage" />

        </a-card>
    </page-header-wrapper>
</template>

<script>

import { faceSwapTaskList } from '@/api/video/video'
import { tableMixin } from '@/store/table-mixin'

export default {
    name: 'SimplePageQuery',
    mixins: [tableMixin],
    data() {
        return {
            loading: false,
            total: 0,
            list: [],
            queryParam: {
                keyword: undefined,
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    computed: {
        columns() {
            return [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'center'
                },
                {
                    title: '用户昵称',
                    dataIndex: 'nickname',
                    align: 'center'
                },
                {
                    title: '短剧名称',
                    dataIndex: 'videoName',
                    align: 'center'
                },
                {
                    title: '消耗金币',
                    dataIndex: 'coins',
                    align: 'center'
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    align: 'center'
                }
            ]
        }

    },
    created() {
        this.getList()
    },
    methods: {
        /** 分页查询 */
        getList() {
            this.loading = true

            faceSwapTaskList(this.queryParam).then(res => {
                this.list = res.data.records
                this.total = res.data.total
                this.loading = false
            })
        },

        /** 查询 */
        handleQuery() {
            this.queryParam.pageNum = 1
            this.getList()
        },

        /** 重置 */
        resetQuery() {
            this.queryParam = {
                keyword: undefined,
                pageNum: 1,
                pageSize: 10
            }
            this.getList()
        },

        /** 修改 pageSize */
        onShowSizeChange(current, pageSize) {
            this.queryParam.pageSize = pageSize
            this.getList()
        },

        /** 翻页 */
        changePage(current) {
            this.queryParam.pageNum = current
            this.getList()
        }
    }
}
</script>
